export const blogPosts = [
  {
    id: 1,
    title: "How to Choose the Perfect Product for You",
    excerpt: "Our ultimate guide to finding exactly what you need while shopping online at Pure Clean Shopping.",
    date: "2025",
    content: `
      <p>Choosing the right product can be overwhelming in today’s online marketplace. With so many options, styles, and features to choose from, it’s easy to feel lost. Here at <strong>Pure Clean Shopping</strong>, we’ve simplified the process so you can make confident, informed decisions every time you shop.</p>
      
      <h3>1. Identify Your Needs</h3>
      <p>Before you start browsing, take a moment to think about what problem you’re trying to solve or what benefit you’re seeking. Are you shopping for comfort, durability, affordability, or design? Defining this helps narrow down your search instantly.</p>

      <h3>2. Read the Descriptions Carefully</h3>
      <p>Our product pages are detailed with essential information like size, material, care instructions, and warranty details. A closer look at these can help you avoid returns and ensure you get exactly what you expect.</p>

      <h3>3. Check Reviews & Ratings</h3>
      <p>Customer feedback is your best friend. Read what others have said about their experiences — this gives real-world insight into quality, performance, and usability.</p>

      <h3>4. Compare Before You Buy</h3>
      <p>Use our “Compare” feature to evaluate multiple products side-by-side. This allows you to clearly see what each product offers and which one gives you the best value for your money.</p>

      <h3>5. Take Advantage of Offers</h3>
      <p>Pure Clean Shopping often runs <strong>seasonal sales</strong>, discount codes, and bundle offers. Keep an eye on our homepage or subscribe to our newsletter so you never miss a deal!</p>

      <p>With these simple steps, shopping becomes not only easy but enjoyable. Explore our catalog today and find products that truly fit your lifestyle.</p>
    `,
    img: "/assests/banners/b1.jpg"
  },
  {
    id: 2,
    title: "Announcing Our New Fall Collection",
    excerpt: "Cozy textures, earthy tones, and timeless styles — discover what’s trending this fall.",
    date: "2025",
    content: `
      <p>We’re thrilled to introduce our all-new <strong>Fall Collection 2025</strong> — a celebration of comfort, craftsmanship, and modern style. This season, we bring you fashion that combines classic autumn vibes with sustainable materials and everyday functionality.</p>
      
      <h3>What’s New This Season?</h3>
      <ul>
        <li>✨ <strong>Organic Cotton Scarves</strong> – Soft, breathable, and ethically sourced.</li>
        <li>👢 <strong>Handcrafted Leather Boots</strong> – Designed for comfort and durability.</li>
        <li>🧥 <strong>Wool-Blend Coats</strong> – Perfect for layering and staying warm in style.</li>
        <li>👜 <strong>Minimalist Crossbody Bags</strong> – The perfect accessory for every occasion.</li>
      </ul>

      <h3>Color Trends for Fall 2025</h3>
      <p>This year, our color palette is inspired by nature — think <strong>rust orange, olive green, deep maroon, and beige</strong>. These shades add warmth and sophistication to any outfit.</p>

      <h3>Why Shop Our Fall Line?</h3>
      <p>Every piece is designed with sustainability in mind. We’ve partnered with eco-friendly manufacturers to reduce waste and ensure fair production. Fashion can look good and do good — and our fall collection proves it.</p>

      <p>Step into the season with confidence. Explore the new arrivals and embrace the fall vibes at <strong>Pure Clean Shopping</strong> today!</p>
    `,
    img: "/assests/banners/b2.jpg"
  },
  {
    id: 3,
    title: "A Complete Guide to Our Shipping & Delivery",
    excerpt: "Here’s everything you need to know about our fast and reliable delivery process.",
    date: "2025",
    content: `
      <p>At <strong>Pure Clean Shopping</strong>, we understand how important timely delivery is. That’s why we’ve built a system that ensures your products reach you quickly and safely, no matter where you are in the world.</p>
      
      <h3>Standard Shipping</h3>
      <p>Our most affordable option. Standard delivery usually takes <strong>5–7 business days</strong>. You’ll receive real-time tracking updates via email as soon as your order is processed.</p>

      <h3>Express Shipping</h3>
      <p>Need your items in a hurry? Choose our <strong>Express Delivery</strong> option to get your products within <strong>2–3 business days</strong>. Perfect for last-minute gifts or urgent replacements.</p>

      <h3>International Shipping</h3>
      <p>We’re proud to ship globally! Delivery times and costs vary by country, but all international shipments are handled with care. You’ll be notified every step of the way with tracking and customs information.</p>

      <h3>Safe & Secure Packaging</h3>
      <p>We use recyclable, eco-friendly packaging that protects your items from damage during transit. Each parcel is carefully inspected before shipping.</p>

      <h3>Easy Returns</h3>
      <p>If something isn’t right, you can easily initiate a return within <strong>30 days</strong> of delivery. We’ll guide you through a quick process to exchange or refund your order.</p>

      <p>Our goal is simple — to make your shopping experience smooth, transparent, and worry-free. Shop with confidence knowing your orders are in safe hands.</p>
    `,
    img: "/assests/banners/b3.jpg"
  }
];
